// @/src/types/Post.ts

import moment from "moment";
import { IPost } from "./IPost";

export class Post implements IPost {
    id: number = 0;
    platform_id: string = '';
    platform: string = '';
    link: string = '';
    text: string = '';
    viewsCount: number = 0;
    reactionsCount: number = 0;
    publicationDate: string | null = null;
    isDeleted: boolean = false;
    forwardedFrom: string | null = null;
    channelId: number | null = null;
    mentionsCount: number | null = null;
    forwardsCount: number | null = null;
    commentsCount: number | null = null;
    sharesCount: number | null = null;
    likes_detailed: Record<string, number> | null = null;
    attachments: any[] | null = null;
    views_history: Array<{ date: string; viewsGrowth: number }> | null = null;
    likes_history: Array<{ date: string; likes: number }> | null = null;
    // Для совместимости
    date: number | null = null;
    deleted_at: number | null = null;
    views: any[] | null = null;

    constructor(o: Partial<IPost>) {
        Object.assign(this, o);
        // Если есть publicationDate, преобразуем в Unix для поля date (для обратной совместимости)
        if (this.publicationDate) {
            this.date = moment(this.publicationDate).unix();
        }
    }

    // Геттеры для совместимости со старым кодом (если используются)
    public get publicationTime(): number | null {
        return this.publicationDate ? moment(this.publicationDate).unix() : null;
    }
    public get deletedAtDate(): number | null {
        return this.deleted_at !== null ? this.deleted_at : null;
    }
    public get deletedAtTime(): number | null {
        return this.deleted_at !== null ? this.deleted_at : null;
    }
    public get groupId(): number | null {
        // Если нужно, можно вычислить из channelId или вообще убрать
        return this.channelId;
    }

    // Вычисление просмотров за 12, 24, 48 часов (используем views_history, если есть)
    private getViewsHistory(): Array<{ date: string; viewsGrowth: number }> {
        return this.views_history || [];
    }

    private getViewsArray(): Array<{ date: string; viewsGrowth: number }> {
        // Преобразуем views_history в формат { date, viewsGrowth }
        const history = this.getViewsHistory();
        if (history.length === 0) return [];
        // Сортируем по дате
        const sorted = [...history].sort((a, b) => moment(a.date).diff(moment(b.date)));
        // // Вычисляем прирост как разницу между соседними днями (для совместимости)
        // const result = [];
        // for (let i = 0; i < sorted.length; i++) {
        //     const current = sorted[i];
        //     const prev = i > 0 ? sorted[i - 1] : null;
        //     const viewsGrowth = prev ? current.viewsGrowth - prev.viewsGrowth : current.viewsGrowth;
        //     result.push({ date: current.date, viewsGrowth });
        // }
        return sorted;
    }

    public get views12(): number | null {
        if (!this.publicationDate) return null;
        const pub = moment(this.publicationDate);
        const viewsData = this.getViewsArray();
        if (viewsData.length === 0) return null;
        let total = 0;
        for (const entry of viewsData) {
            const dt = moment(entry.date);
            const diffHours = Math.ceil(dt.diff(pub, 'minutes') / 60);
            if (diffHours <= 12 && diffHours >= 0) {
                total += entry.viewsGrowth;
            }
        }
        return total || null;
    }

    public get views24(): number | null {
        if (!this.publicationDate) return null;
        const pub = moment(this.publicationDate);
        const viewsData = this.getViewsArray();
        if (viewsData.length === 0) return null;
        let total = 0;
        for (const entry of viewsData) {
            const dt = moment(entry.date);
            const diffHours = Math.ceil(dt.diff(pub, 'minutes') / 60);
            if (diffHours <= 24 && diffHours >= 0) {
                total += entry.viewsGrowth;
            }
        }
        return total || null;
    }

    public get views48(): number | null {
        if (!this.publicationDate) return null;
        const pub = moment(this.publicationDate);
        const viewsData = this.getViewsArray();
        if (viewsData.length === 0) return null;
        let total = 0;
        for (const entry of viewsData) {
            const dt = moment(entry.date);
            const diffHours = Math.ceil(dt.diff(pub, 'minutes') / 60);
            if (diffHours <= 48 && diffHours >= 0) {
                total += entry.viewsGrowth;
            }
        }
        return total || null;
    }
}